var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Loader, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SearchableMenu, SearchableMenuMultiSelectList } from 'shared/domains/common-ui/SearchableMenu';
import { AddMetadataForm } from './AddMetadataForm';
import { AddMetadataListDocument } from './AddMetadataList.gql';
import { AddMetadataRenderItem } from './AddMetadataRenderItem';
import { useMetadataActions } from '../../hooks/useMetadataActions';
import { hasMetadataValue } from '../hasMetadataValue';
export function AddMetadataMenu(props) {
    const { documentId, where } = props;
    const [open, setOpen] = useState(false);
    const actions = useMetadataActions();
    const { data, loading, error, refetch } = useQuery(AddMetadataListDocument, {
        skip: !open,
        variables: {
            documentId,
            where,
        },
    });
    const { addToast } = useToast();
    const { documentMetadataProperties, documentMetadataPairs } = data || {};
    const items = documentMetadataProperties || [];
    const getInitialData = (propertyName) => {
        const match = documentMetadataPairs === null || documentMetadataPairs === void 0 ? void 0 : documentMetadataPairs.find((p) => p.property.name === propertyName);
        if (!match) {
            return {
                id: undefined,
                value: '',
                name: propertyName,
            };
        }
        return {
            id: match.id,
            value: match === null || match === void 0 ? void 0 : match.value,
            name: propertyName,
        };
    };
    const handleSave = (formValues) => __awaiter(this, void 0, void 0, function* () {
        const hasValue = hasMetadataValue(formValues.value);
        try {
            if (!hasValue && formValues.id) {
                yield actions.delete(formValues.id);
            }
            else if (hasValue && formValues.id) {
                yield actions.update({
                    id: formValues.id,
                    value: formValues.value,
                });
            }
            else if (hasValue) {
                yield actions.create({
                    propertyName: formValues.name,
                    value: formValues.value,
                    documentId,
                });
            }
            setOpen(false);
        }
        catch (_a) {
            addToast({
                title: t({
                    message: 'An error occurred',
                    comment: 'Metadata: Error toast when creating/updating metadata',
                }),
                appearance: 'danger',
            });
        }
    });
    return (<SearchableMenu items={items} keys={['label']} open={open && !loading} onClose={() => setOpen(false)} renderTarget={<Button size="xs" $stretch appearance={error ? 'danger' : 'secondary'} disabled={loading} onClick={() => (error ? refetch() : setOpen(true))}>
          {loading || actions.loading ? <Loader /> : <Falcon icon="plus"/>}
          <Trans id="metadata.list.action.show" comment="Metadata actions: Button to show list of available metadata tags to add">
            Add
          </Trans>
        </Button>}>
      <SearchableMenuMultiSelectList renderListWrapper={false} renderItem={(item) => (<AddMetadataForm key={item.id} from={item} initialValues={getInitialData(item.name)} onSubmit={handleSave}>
            <AddMetadataRenderItem from={item}/>
          </AddMetadataForm>)}/>
    </SearchableMenu>);
}
